"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregateEventTypesOut = void 0;
class AggregateEventTypesOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return AggregateEventTypesOut.attributeTypeMap;
    }
}
exports.AggregateEventTypesOut = AggregateEventTypesOut;
AggregateEventTypesOut.discriminator = undefined;
AggregateEventTypesOut.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "string",
        "format": ""
    },
    {
        "name": "status",
        "baseName": "status",
        "type": "BackgroundTaskStatus",
        "format": ""
    },
    {
        "name": "task",
        "baseName": "task",
        "type": "BackgroundTaskType",
        "format": ""
    }
];
//# sourceMappingURL=AggregateEventTypesOut.js.map